import {
  MethodCategoriesEnum,
  ResultType,
  ResultTypesEnum,
  StaticallyTypedMethod,
  UnknownResult,
} from './internal';

export class UnknownMethod extends StaticallyTypedMethod {
  constructor() {
    super(MethodCategoriesEnum.PROPERTY, UnknownResult);
  }
}

export const unknownType: ResultType = {
  name: ResultTypesEnum.UNKNOWN,
  properties: {},
  methods: {},
};
